import { Dictionary } from '@models/common';
import { flatten } from 'lodash-es';

export function extractError(error: Dictionary): string[] {
  if (error.errors && error.errors) {
    return error.errors.map((i: Dictionary) => i.message);
  }
  return flatten(Object.values(error.errors));
}
